module.exports = __webpack_public_path__ + "media/fundo.40fb9370.mp3";